///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { division as divisionType } from "./types";

export const getDefaultRadius = (lane, division) => {
  let radius = null;

  if (division === divisionType.coy) {
    const distance = lane.coyoteMiles;
    if (distance <= 50) {
      radius = 10;
    } else if (distance <= 150) {
      radius = 20;
    } else if (distance <= 500) {
      radius = 40;
    } else if (distance <= 1500) {
      radius = 75;
    } else {
      radius = 125;
    }
  } else {
    const distance = lane.coyoteDistance;
    if (distance <= 50) {
      radius = 50;
    } else if (distance <= 150) {
      radius = 75;
    } else if (distance <= 500) {
      radius = 100;
    } else if (distance <= 1500) {
      radius = 125;
    } else {
      radius = 150;
    }
  }

  return {
    originRadius: radius,
    destinationRadius: radius
  };
};

export default getDefaultRadius;
